import { usePostTrackEventWithParams } from "./analyticsQueries"
import { TLogFilterContext } from "./logAnalyticsQueries"

export type TPresenceAndCrowdDetectEventTypes =
  | "Presence And Crowd Detect Popup Opened"
  | "Crowd Detect Toggled"
  | "Presence Detection Toggled"
  | "Presence And Crowd Detect Toggled"

function usePostPresenceAndCrowdDetectTrackingEvent<TEventProperties>(
  event: TPresenceAndCrowdDetectEventTypes
) {
  return usePostTrackEventWithParams<
    TPresenceAndCrowdDetectEventTypes,
    TEventProperties
  >({
    event,
  })
}

// Presence And Crowd Detect Popup Opened
export type TPresenceAndCrowdDetectPopupOpenedProperties = {
  context: "unit_overview" | "properties_units"
  presence_detection_enabled: boolean
  crowd_detect_enabled: boolean
}
export function usePostPresenceAndCrowdDetectPopupOpened() {
  return usePostPresenceAndCrowdDetectTrackingEvent<TPresenceAndCrowdDetectPopupOpenedProperties>(
    "Presence And Crowd Detect Popup Opened"
  )
}

// Crowd Detect Toggled
export type TCrowdDetectToggledEventProperties = {
  new_toggle_status: "enabled" | "disabled"
  presence_detection_enabled: boolean
}
export function usePostCrowdDetectToggled() {
  return usePostPresenceAndCrowdDetectTrackingEvent<TCrowdDetectToggledEventProperties>(
    "Crowd Detect Toggled"
  )
}

// Presence Detection Toggled
export type TPresenceDetectionToggledEventProperties = {
  new_toggle_status: "enabled" | "disabled"
  crowd_detect_enabled: boolean
}
export function usePostPresenceDetectionToggled() {
  return usePostPresenceAndCrowdDetectTrackingEvent<TPresenceDetectionToggledEventProperties>(
    "Presence Detection Toggled"
  )
}

// Presence And Crowd Detect Toggled
export type TPresenceAndCrowdDetectToggledEventProperties = {
  new_toggle_status: "enabled" | "disabled"
  presence_detection_enabled: boolean
  crowd_detect_enabled: boolean
}
export function usePostPresenceAndCrowdDetectToggled() {
  return usePostPresenceAndCrowdDetectTrackingEvent<TPresenceAndCrowdDetectToggledEventProperties>(
    "Presence And Crowd Detect Toggled"
  )
}

export function usePostTrackPresenceDetectionClickedEvent() {
  return usePostTrackEventWithParams<
    "Presence Event Clicked",
    {
      context: TLogFilterContext
      type: "arrival" | "no_show"
    }
  >({
    event: "Presence Event Clicked",
  })
}
